import { Entity } from '@betgames/bg-state-manager';
import { GameId } from '@bg-shared/enums/GameId';
import { GameState } from '@bg-shared/enums/GameState';
import { IGameStatusModel } from './interfaces';

export default class GamesStatusEntity extends Entity<IGameStatusModel, GameId> {
    constructor() {
        super({
            key: 'GamesStatus',
            default: {
                state: GameState.LIVE,
                started: false,
                openForBets: false,
            },
        });
    }

    public setState(gameId: GameId, state: GameState): void {
        this.store(gameId).update((draft) => {
            draft.state = state;
        });
    }

    public setStarted(gameId: GameId, started: boolean): void {
        this.store(gameId).update((draft) => {
            draft.started = started;
        });
    }

    public setOpenForBets(gameId: GameId, openForBets: boolean): void {
        this.store(gameId).update((draft) => {
            draft.openForBets = openForBets;
        });
    }
}

export const gamesStatusEntity = new GamesStatusEntity();
